import { createBlock } from 'factories/block';
import { InteractionProps, repeat } from './interaction';
import { createLayout } from 'factories/layout';
import { colors } from 'styles/variables';
import { createContinueBtn } from './continueBtn';
import { createEditableBtn } from './editableBtn';
import { getSId } from '../utils';
import { getPlaceholderText } from './text';

const { lPink } = colors;

export type FiveStarRatingInteractionProps = InteractionProps & {
  //
};

export const createFiveStarRatingBlock = (count: number) => {
  return createBlock('FiveStarRating', [
    createBlock('FiveStarList', [
      ...repeat(() => createBlock('Star'), count || 5),
    ]),
    createBlock('TextArea'),
    createEditableBtn({ label: 'Submit' }),
    createBlock('FeedbackSubmitted', [
      createBlock('Image'),
      createBlock('Text'),
    ]),
  ]);
};

const contentForColumn = (count: number, isTextEntry: boolean) => (
  i: number
) => {
  return [
    () =>
      createBlock('Text', [], {
        props: {
          useBackgroundControls: true,
          content: getPlaceholderText(
            !isTextEntry ? 'h1' : 'h2',
            !isTextEntry ? 'heading-one' : 'heading-two'
          ),
          className: 'text-align-center',
        },
      }),
    () => createFiveStarRatingBlock(count),
  ][i];
};

export const createFiveStarRatingInteractionBlock = (
  props: FiveStarRatingInteractionProps
) => {
  const {
    starColor = '#B2B6CA',
    submissionEmailDestination = '',
    subject = '',
    lockDown = 0,
    style,
    isTextEntry = false,
  } = props as any;

  return createBlock(
    'Interaction',
    [
      createLayout(contentForColumn(0, isTextEntry), 0, true),
      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        type: 'FiveStarRating',
        name: props.name,
        sId: getSId('interaction'),
        style: props.style,
        starColor,
        submissionEmailDestination,
        subject,
        lockDown,
        isTextEntry,
      },
      meta: {
        subType: 'FiveStarRating',
        layout: 'OneColumnReversed',
      },
    }
  );
};

export const create = createFiveStarRatingInteractionBlock;
export const interactionConfig = {};
